import React from "react";
import classes from "./UnderwriterList.module.css";
import { Col, Row } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";

export interface Underwriter {
  id: number;
  name: string;
  patronymic: string;
  surname: string;
}

interface UnderwriterListProps {
  underwriters: readonly Underwriter[];
  selectedUnderwriter: Underwriter | null;
  setSelectedUnderwriter: (underwriter: Underwriter) => void;
}

export const UnderwriterList = (props: UnderwriterListProps) => {
  const { underwriters, selectedUnderwriter, setSelectedUnderwriter } = props;

  const checkIsSelected = (underwriter: Underwriter) => {
    return selectedUnderwriter?.id === underwriter.id;
  };

  return (
    <Col className={classes.list}>
      {underwriters.map((underwriter) => {
        const { id, name, surname, patronymic } = underwriter;
        return (
          <Row
            key={id}
            className={`${classes.listItem} ${
              checkIsSelected(underwriter) && classes.listItemSelected
            }`}
            onClick={() => setSelectedUnderwriter(underwriter)}
          >
            <span>{`${surname} ${name} ${patronymic}`}</span>

            {checkIsSelected(underwriter) && (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            )}
          </Row>
        );
      })}
    </Col>
  );
};
